/** The server couldn't be reached (offline, DNS, timeout, proxy down…): retry later. */
export class NetworkError extends Error {}
